module.exports = __webpack_public_path__ + "img/GE_top_right.299628d3.jpg";